export default __webpack_public_path__ + "9997686be4c4fbd8a85adf30e83965df.ttf";